export default __webpack_public_path__ + "static/protect-88bca20eb511f3d573dba6149bcedc35.png";